<mat-card>
  <mat-card-content>
    <p>{{ title() }}</p>
    <small>{{ series().length }} points</small>
  </mat-card-content>
</mat-card>
